import { useMemo, useState } from "react";
import { HorizontalStackedBarChartCard, ChartFilterBar } from "../../../components/Charts";
import type { FilterDefinition, FilterValues } from "../../../types/chartFilters";
import type { FilterOnChange } from "../../../components/Charts/ChartFilterBar";
import { useP5Data, type P5FilterValues } from "./useP5ChartData";
import CompareButton from "../common/CompareButton";

const DEFAULT_FILTERS: P5FilterValues = {
  comarca: undefined,
  sector:  undefined,
};

const P5ChartSection = () => {
  const [filters, setFilters] = useState<P5FilterValues>(DEFAULT_FILTERS);
  const { chartData, bars, availableComarques, availableSectors, loading, error } =
    useP5Data(filters);

  const filterDefs: FilterDefinition[] = useMemo(() => [
    {
      type: "select" as const,
      key: "comarca",
      label: "Comarca",
      clearable: true,
      options: availableComarques.map((c) => ({ value: c, label: c })),
    },
    {
      type: "select" as const,
      key: "sector",
      label: "Sector",
      clearable: true,
      options: availableSectors.map((s) => ({ value: s, label: s })),
    },
  ], [availableComarques, availableSectors]);

  const handleFilterChange: FilterOnChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value || undefined }));
  };

  return (
    <>
      <ChartFilterBar
        filters={filterDefs}
        values={filters as unknown as FilterValues}
        onChange={handleFilterChange}
        disabled={loading}
      />
      <HorizontalStackedBarChartCard
        title="Índex d'Alineament Universitari-Productiu per comarca i sector (IAUP)"
        data={chartData}
        yKey="nom_comarca"
        bars={bars}
        loading={loading}
        error={error}
        xDomain={[0, "auto"]}
        tooltipSuffix=""
        stacked={false}
        labelMinThreshold={0}
      />
      <CompareButton />
    </>
  );
};

export default P5ChartSection;
